import { useToasteo } from '@deegital/vue-trustup-io-toasteo';

export default function useToasteoError(translationKeyOrText = 'toasts.error', raw = false) {
    const { t } = useTranslation();
    const toasteo = useToasteo();
    return toasteo.error({
        text: raw ? translationKeyOrText : t(translationKeyOrText),
    });
}
